module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bj-fb3d1c01b8a808e6fe1335322cb758a6.svg";